import { Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
/** USA **/
import AgreementUSAESP from '../Legales/AgreementUSA/ESP';
import AgreementUSAING from '../Legales/AgreementUSA/ING';
import PrivacyUSAESP from '../Legales/PrivacyUSA/ESP';
import PrivacyUSAENG from '../Legales/PrivacyUSA/ENG';
import PoliciesAndProceduresUSAESP from '../Legales/PoliciesAndProcedures/ESP';
import PoliciesAndProceduresUSAING from '../Legales/PoliciesAndProcedures/ING';
import FaqUSAESP from '../Legales/FaqUSA/ESP';
import FaqUSAENG from '../Legales/FaqUSA/ENG';
import MamualUSAESP from '../Legales/ManualUSA/ESP';
import MamualUSAENG from '../Legales/ManualUSA/ENG';
import CaliforniaPrivacyESP from '../Legales/CaliforniaPrivacyUSA/ESP';
import CaliforniaPrivacyING from '../Legales/CaliforniaPrivacyUSA/ING';
import MenuLegales from './Menu';
import TestimoniosMenu from './Testimonios';
import RedesSocialesMenu from './RedesSociales';
import ProductosMenu from './Productos';

/** MEX **/
import PrivacyMX from '../Legales/PrivacyMX';
import TermsMX from '../Legales/TermsMX';

export default function Legal({ match, history, device }) {
  const { i18n = {} } = useTranslation();
  const { language = '' } = i18n;
  return (
    <div>
      <Switch>
        {/** USA **/}
        <Route
          exact
          path={`${match.path}/faq_us`}
          render={(props) => {
            if (language.includes('es'))
              return <FaqUSAESP {...props} device={device} history={history} match={match} />;
            else return <FaqUSAENG {...props} device={device} history={history} match={match} />;
          }}
        />
        <Route
          exact
          path={`${match.path}/manual_us`}
          render={(props) => {
            if (language.includes('es'))
              return <MamualUSAESP {...props} device={device} history={history} match={match} />;
            else return <MamualUSAENG {...props} device={device} history={history} match={match} />;
          }}
        />

        {/** México **/}
        <Route
          exact
          path={`${match.path}/aviso_de_privacidad_mx`}
          render={(props) => {
            return <PrivacyMX {...props} device={device} history={history} match={match} />;
          }}
        />
        <Route
          exact
          path={`${match.path}/terminos_y_condiciones_mx`}
          render={(props) => {
            return <TermsMX {...props} device={device} history={history} match={match} />;
          }}
        />

        {/* RUTA PARA EL MENU PRINCIPAL  */}
        <Route
          path={`${match.path}`}
          // render={(props) => {
          //   return <MenuLegales {...props} device={device} history={history} />;
          // }}
        >
          <MenuLegales device={device}>
            <Switch>
              <Route
                exact
                path={`${match.path}/consultant_agreement_us`}
                render={(props) => {
                  if (language.includes('es'))
                    return (
                      <AgreementUSAESP {...props} device={device} history={history} match={match} />
                    );
                  else
                    return (
                      <AgreementUSAING {...props} device={device} history={history} match={match} />
                    );
                }}
              />

              <Route
                exact
                path={`${match.path}/privacy_policy_us`}
                render={(props) => {
                  if (language.includes('es'))
                    return (
                      <PrivacyUSAESP {...props} device={device} history={history} match={match} />
                    );
                  else
                    return (
                      <PrivacyUSAENG {...props} device={device} history={history} match={match} />
                    );
                }}
              />

              <Route
                exact
                path={`${match.path}/policies_and_procedures_us`}
                render={(props) => {
                  if (language.includes('es'))
                    return (
                      <PoliciesAndProceduresUSAESP
                        {...props}
                        device={device}
                        history={history}
                        match={match}
                      />
                    );
                  else
                    return (
                      <PoliciesAndProceduresUSAING
                        {...props}
                        device={device}
                        history={history}
                        match={match}
                      />
                    );
                }}
              />

              <Route
                exact
                path={`${match.path}/california_privacy_notice`}
                render={(props) => {
                  if (language.includes('es'))
                    return (
                      <CaliforniaPrivacyESP
                        {...props}
                        device={device}
                        history={history}
                        match={match}
                      />
                    );
                  else
                    return (
                      <CaliforniaPrivacyING
                        {...props}
                        device={device}
                        history={history}
                        match={match}
                      />
                    );
                }}
              />

              <Route
                exact
                path={`${match.path}/testimonios`}
                render={(props) => {
                  return (
                    <TestimoniosMenu
                      {...props}
                      device={device}
                      history={history}
                      idioma={language}
                    />
                  );
                }}
              />

              <Route
                exact
                path={`${match.path}/redesSociales`}
                render={(props) => {
                  return (
                    <RedesSocialesMenu
                      {...props}
                      device={device}
                      history={history}
                      idioma={language}
                    />
                  );
                }}
              />

              <Route
                exact
                path={`${match.path}/productosTestimonios`}
                render={(props) => {
                  return (
                    <ProductosMenu {...props} device={device} history={history} idioma={language} />
                  );
                }}
              />
            </Switch>
          </MenuLegales>
        </Route>
      </Switch>
    </div>
  );
}
